import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=3f32590c&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=3f32590c&prod&scoped=true&lang=css"
import style1 from "./CategoryFilter.vue?vue&type=style&index=1&id=3f32590c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32590c",
  null
  
)

export default component.exports